/**
 * Typeahead dentro de modales con scroll.
 *
 * Bootstrap recorta con `overflow` el `.modal-body` (y el `.modal-content`) de
 * los modales `modal-dialog-scrollable`, así que el menú de typeahead.js, que es
 * `position: absolute` dentro del `.twitter-typeahead`, se corta en el borde del
 * cuerpo del modal (la lista de colonias del formulario de cliente, por ejemplo).
 * Un z-index no lo arregla: el recorte lo hace el contenedor con overflow.
 *
 * Solución: mientras el menú está abierto dentro de un modal se saca del flujo
 * con `position: fixed` y se coloca con las coordenadas reales del input en el
 * viewport (por encima del modal, z-index 1060 > 1055 de Bootstrap). Al cerrar
 * se devuelve al estilo inline que typeahead.js le puso. Si el cuerpo del modal
 * o la página hacen scroll con el menú abierto, se recoloca.
 *
 * Los eventos `typeahead:*` los dispara el plugin sobre el input y burbujean, así
 * que basta con delegarlos en `document`: cubre los typeaheads que se crean y
 * destruyen en runtime (colonias por código postal).
 */

export var Z_INDEX_MENU_EN_MODAL = 1060;   // modal de Bootstrap 5 = 1055
var SEPARACION = 2;                        // mismo margen que el menú absoluto
var ALTO_MAXIMO_MENU = 300;                // coincide con el max-height del CSS

/**
 * Coordenadas fijas del menú a partir del rectángulo del input.
 *
 * Se prefiere abajo. Solo se abre hacia arriba cuando abajo no cabe ni el
 * alto real del menú y arriba sí hay más espacio; así el menú nunca queda
 * fuera del viewport por el borde inferior con la lista recortada.
 *
 * @param {{top:number,bottom:number,left:number,width:number}} rect  input en el viewport
 * @param {{height:number}} viewport
 * @param {number} altoMenu  alto real del menú (o el máximo si aún no se midió)
 * @returns {{top:number,left:number,width:number,arriba:boolean}}
 */
export function calcularPosicionMenu(rect, viewport, altoMenu) {
  var alto = Math.min(Number(altoMenu) || ALTO_MAXIMO_MENU, ALTO_MAXIMO_MENU);
  var espacioAbajo = viewport.height - rect.bottom - SEPARACION;
  var espacioArriba = rect.top - SEPARACION;
  var arriba = espacioAbajo < alto && espacioArriba > espacioAbajo;
  return {
    top: Math.round(arriba ? Math.max(0, rect.top - SEPARACION - alto) : rect.bottom + SEPARACION),
    left: Math.round(rect.left),
    width: Math.round(rect.width),
    arriba: arriba
  };
}

function $menuDe($input) {
  return $input.closest('.twitter-typeahead').find('.tt-menu');
}

function fijar($input) {
  var $menu = $menuDe($input);
  var input = $input[0];
  if (!$menu.length || !input || !$menu.is(':visible')) return;
  var pos = calcularPosicionMenu(
    input.getBoundingClientRect(),
    { height: window.innerHeight || document.documentElement.clientHeight },
    $menu[0].offsetHeight
  );
  $menu.addClass('fd-tt-fijo').css({
    position: 'fixed',
    top: pos.top + 'px',
    left: pos.left + 'px',
    width: pos.width + 'px',
    zIndex: Z_INDEX_MENU_EN_MODAL
  });
}

function soltar($input) {
  var $menu = $menuDe($input);
  if (!$menu.length) return;
  // De vuelta al posicionamiento inline que typeahead.js le da al menú.
  $menu.removeClass('fd-tt-fijo').css({ position: 'absolute', top: '100%', left: 0, width: '', zIndex: '' });
}

/** Un solo listener global; los inputs se detectan por evento, no por selector fijo. */
export function initTypeaheadEnModales() {
  if (typeof window === 'undefined' || !window.jQuery) return;
  var $ = window.jQuery;
  var $doc = $(document);
  if ($doc.data('fdTypeaheadModal')) return;
  $doc.data('fdTypeaheadModal', true);

  var SEL = '.modal .tt-input';
  $doc.on('typeahead:open typeahead:render', SEL, function () { fijar($(this)); });
  $doc.on('typeahead:close', SEL, function () { soltar($(this)); });

  // El scroll del cuerpo del modal no burbujea: se escucha en captura.
  var recolocar = function () {
    $('.modal .tt-menu.fd-tt-fijo:visible').each(function () {
      fijar($(this).closest('.twitter-typeahead').find('.tt-input'));
    });
  };
  document.addEventListener('scroll', recolocar, true);
  window.addEventListener('resize', recolocar);

  // typeahead('destroy') NO dispara typeahead:close (verificado en 0.11.1): si la
  // respuesta del código postal llega con el menú abierto, el menú fijo quedaría
  // huérfano en pantalla. Se suelta y se oculta ANTES de destruir.
  var typeaheadOriginal = $.fn.typeahead;
  if (typeof typeaheadOriginal === 'function' && !typeaheadOriginal.fdEnvuelto) {
    var envuelto = function (metodo) {
      if (metodo === 'destroy') {
        this.each(function () {
          var $menu = $menuDe($(this)).filter('.fd-tt-fijo');
          if ($menu.length) { soltar($(this)); $menu.hide(); }
        });
      }
      return typeaheadOriginal.apply(this, arguments);
    };
    envuelto.fdEnvuelto = true;
    $.extend(envuelto, typeaheadOriginal); // conserva noConflict y demás estáticos
    $.fn.typeahead = envuelto;
  }

  // Red de seguridad: al cerrarse cualquier modal no debe quedar un menú fijo visible.
  $doc.on('hidden.bs.modal', '.modal', function () {
    $(this).find('.tt-menu.fd-tt-fijo').each(function () {
      soltar($(this).closest('.twitter-typeahead').find('.tt-input'));
      $(this).hide();
    });
  });
}
